import type { NavigateFunction } from 'react-router-dom';
import ga from '../services/analytics';
import { relayMetaCapiEvent, createMetaEventId } from '../services/metaCapiRelay';
import { preserveUtmParams } from './utm';
import { buildAbsoluteAppUrl, isSocialEmbeddedBrowser } from './embeddedBrowser';
import { openInExternalBrowser } from './openInExternalBrowser';

export type LandingSignInPlacement = 'header' | 'hero' | 'mcp' | 'footer';

export function goToSignIn(navigate: NavigateFunction, placement: LandingSignInPlacement): void {
  const eventId = createMetaEventId('ViewContent', placement);
  ga.event('landing_sign_in_click', { placement, event_id: eventId });
  relayMetaCapiEvent('ViewContent', { placement, eventId });
  const loginPath = preserveUtmParams('/auth/login');
  const embedded = isSocialEmbeddedBrowser();

  if (embedded.isEmbedded) {
    ga.event('landing_sign_in_open_external', { placement, app_key: embedded.appKey ?? 'unknown' });
    openInExternalBrowser(embedded.appKey, buildAbsoluteAppUrl(loginPath));
    return;
  }

  navigate(loginPath);
}
